<button [routerLink]="route" class="px-4 py-2 rounded-md bg-primary text-white font-medium shadow-md
         hover:bg-primary/99 transition-all duration-300 flex items-center cursor-pointer">
  <ng-icon name="featherArrowLeft" size="20"></ng-icon>
</button>
